const gitInfo = {"gitBranch":"HEAD","gitCommitHash":"bc4126d","wip":false,"buildTime":"2024-04-16 18:02:27"}
export default gitInfo;